import React from "react";
import { LocalizationProvider } from "../context/LocalizationContext";

const WrappedPage = ({ element, props }) => (
  <LocalizationProvider {...props}>
    {element}
  </LocalizationProvider>
);

export default WrappedPage;
